module.exports = "/_next/static/resources/array-07bf81dcce0d43c6fc2a0a5b4525ff67.webp";